import ServicesHero from './components/ServicesHero';
import AllServicesGrid from './components/AllServicesGrid';
import ConstructionSection from './components/ConstructionSection';
import MaintenanceSection from './components/MaintenanceSection';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const Services = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ServicesHero />
      <AllServicesGrid />
      <ConstructionSection />
      <MaintenanceSection />
      <Footer />
    </div>
  );
};

export default Services;
